import { useZoomControlsController } from './zoom-controls.controller';

export function ZoomControls() {
    const { handleZoomIn, handleZoomOut } = useZoomControlsController();

    return (
        <div className='flex items-center gap-3'>
            <button
                onClick={handleZoomOut}
                className='hover:bg-background-subtle bg-background-surface border-border-default flex h-10 w-10 items-center justify-center rounded-lg border transition-colors'
                aria-label='Zoom out'>
                <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M3 8H13'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                </svg>
            </button>
            <button
                onClick={handleZoomIn}
                className='hover:bg-background-subtle bg-background-surface border-border-default flex h-10 w-10 items-center justify-center rounded-lg border transition-colors'
                aria-label='Zoom in'>
                <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M8 3V13M3 8H13'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                </svg>
            </button>
        </div>
    );
}
